export type CustomConsolesKeys = 'error' | 'log' | 'info' | 'warn'

class Logger {
  protected isDev = process.env.NODE_ENV && process.env.NODE_ENV === 'development'

  protected showConsole = (type: CustomConsolesKeys, ...data: any[]) => {
    if (this.isDev) {
      console[type](data)
    } else {
      null
    }
  }

  protected showConsoleWithTrace = (type: CustomConsolesKeys, title: string, ...data: any[]) => {
    if (this.isDev) {
      console.groupCollapsed(title)
      console[type](data)
      console.trace()
      console.groupEnd()
    } else {
      null
    }
  }

  public log = (...data: any[]) => {
    this.showConsole('log', ...data)
  }

  public error = (title: string, ...data: any[]) => {
    this.showConsoleWithTrace('error', title, ...data)
  }

  public info = (...data: any[]) => {
    this.showConsole('info', ...data)
  }

  public warn = (title: string, ...data: any[]) => {
    this.showConsoleWithTrace('warn', title, ...data)
  }
}

export const logger = new Logger()
